import { RemoveRecentConversationUseCase } from './RemoveRecentConversationUseCase'
import { recentConversationsRepository } from '../../../data-access/repositories'

export const removeRecentConversation = new RemoveRecentConversationUseCase({
  recentConversationsRepository,
}).execute
